type WorkstationMode = 'always' | 'signed-in' | 'backup' | 'never';

export class WorkstationUser {
  constructor(
    readonly id: string,
    readonly userId: string,
    readonly mode: WorkstationMode,
  ) {}
}
